import React from 'react';
import MetricsAreaChart from './MetricsAreaChart';
import ReactTooltip from 'react-tooltip';
import { NetworkService } from './../../../services/network.service';
import $ from 'jquery';

class Summary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            privIpv4Add: '',
            ipv4Address: [],
            ipv6Address: '',
            isdatapresent: false,
            isIpv6Copy: true,
            isIpv4Copy: true,
            isSshCopy: true,
            resultIP: ""
        };

        this.bandwidthRef = React.createRef();
        this.cpuRef = React.createRef();
        this.diskRef = React.createRef();

    }

    componentDidMount() {
        $("html").animate({ scrollTop: 0 }, "slow");
        this.getAdditionalIpDetails();
    }

    getAdditionalIpDetails = (param) => {
        NetworkService.getIPDetails(this.props.instance.id).then(resp => {
            if(resp === false) {
                this.props.bgShadowHandler(false);
            }
            if(resp.data == "NO_DETAILS_FOUND") {
                this.setState({
                    additionalIPs: [],
                    additionalIPCount: 0
                });
            }
            if(resp.data != "NO_DETAILS_FOUND") {
                this.setState({
                    additionalIPs: resp.data,
                    additionalIPCount: resp.data.length
                });

            }
            this.setIpAddresses(this.props.instance);

        })
            .catch(error => {
                this.props.bgShadowHandler(false);
            });
    };

    setIpAddresses(instance) {
        if(instance && instance.addresses) {
            let addresses = instance.addresses;
            let ipv4s = [];
            if(addresses['provider.public']) {
                let publicProvider = addresses['provider.public'];
                if(publicProvider && publicProvider.length > 0) {

                    publicProvider.forEach(element => {
                        if(element.version === 6) {
                            this.setState({ ipv6Address: element.addr });
                        } else if(element.version === 4) {
                            let ips = {
                                "ipv4Adrs": element.addr
                            };
                            ipv4s.push(ips);

                        }
                    });

                    this.setState({ ipv4Address: ipv4s });
                }
            }
            if(addresses['provider.private']) {
                let privateProvider = addresses['provider.private'];
                if(privateProvider && privateProvider.length > 0) {
                    privateProvider.forEach(element => {
                        if(element.version === 4) {
                            this.setState({ privIpv4Add: element.addr });
                        }
                    });
                }
            }
        }
        this.getMainIp();
    }

    onSelectTimePeriod = (event) => {
        let timePeriod = 1;
        switch(event.target.value) {
            case '1 week':
                timePeriod = 7;
                break;
            case '1 month':
                timePeriod = 30;
                break;
            default:
                timePeriod = 1;
        }
        this.invokeTimePeriodData(timePeriod);
    };

    invokeTimePeriodData(timePeriod) {
        this.props.bgShadowHandler(true);
        this.bandwidthRef.current.getDataByType(timePeriod);
        this.cpuRef.current.getDataByType(timePeriod);
        this.diskRef.current.getDataByType(timePeriod);
        setTimeout(() => {
            this.props.bgShadowHandler(false);
        }, 4000);
    };

    copyToclipboard = (event, text, type) => {
        if(type === 'isIpv6Copy') {
            this.setState({ isIpv6Copy: false });
        } else if(type === 'isIpv4Copy') {
            this.setState({ isIpv4Copy: false });
        } else {
            this.setState({ isSshCopy: false });
        }
        var container = event.currentTarget;
        let tempInnerHtml = container.innerHTML;
        container.innerHTML = text;
        window.getSelection().removeAllRanges();
        let range = document.createRange();
        range.selectNode(container);
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        container.innerHTML = tempInnerHtml;

    };
    getMainIp = () => {

        let open = this.state.ipv4Address;
        let compute = this.state.additionalIPs;
        let result = open.filter(open => !compute.some(compute => open.ipv4Adrs == compute.ip_address));
        this.setState({
            resultIP: result[0].ipv4Adrs
        });
        //console.log(this.state.additionalIPs.length)

    };

    render() {
        var username = 'root';
        if(this.props.instance.metadata?.instType === 'rancher') username = 'rancher';

        return (

            <section className={ this.state.isdatapresent ? "settingModule_wrapper" : "settingModule_wrapper summary_setting_module" }>
                { this.state.isdatapresent ?
                    <div className="outer_empty_wrap">
                        <div className="inner_empty_wrap">
                            <div className="svg_wrap empty_icon summary_empty"></div>
                            <p className="empty_title">No Overview</p>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="settModule_head_wrap">
                            <div className="settModule_head_lhs">
                                <h2>Overview</h2>
                                <p className="head_info" style={ { display: "none" } }>View network performance, CPU usage, disk operations, and other details of the instance </p>
                            </div>
                            <div className="settModule_head_rhs">
                                <div className="custom_select_box">
                                    <select onChange={ (e) => this.onSelectTimePeriod(e) }>
                                        <option>Last 24 hours</option>
                                        <option>1 week</option>
                                        {/* <option>1 month</option> */ }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="summaryModule_wrap">
                            <div className="summaryModule_lhs">
                                <div className="stat_graph_box">
                                    <h3>Bandwidth</h3>
                                    <MetricsAreaChart type="bandwidth" instanceId={ this.props.instanceId } ref={ this.bandwidthRef } regionName={ this.props.instance.region } />

                                </div>
                                <div className="stat_graph_box">
                                    <h3>CPU %</h3>
                                    <MetricsAreaChart type="cpu" instanceId={ this.props.instanceId } ref={ this.cpuRef } />

                                </div>
                                <div className="stat_graph_box">
                                    <h3>Disk I/O</h3>
                                    <MetricsAreaChart type="diskio" instanceId={ this.props.instanceId } ref={ this.diskRef } />

                                </div>
                            </div>
                            <div className="summaryModule_rhs">
                                <div className="summaryModule_rhs_box">
                                    <h3>IP Addresses</h3>
                                    <div className="summaryRhs_box_content">
                                        <ul className="ip_add_container">
                                            <li style={ { display: this.state.ipv4Address.length > 0 ? 'block' : 'none' } } >
                                                <span className="ip_addr">ssh { username }@{ this.state.resultIP } </span>
                                                <span className="svg_wrap" data-tip data-for="sshCopy" onMouseLeave={ () => this.setState({ isSshCopy: true }) } onClick={ (e) => this.copyToclipboard(e, 'ssh ' + username + '@' + this.state.resultIP, 'isSshCopy') }>
                                                    <svg
                                                        x="0px"
                                                        y="0px"
                                                        width="14px"
                                                        height="16.5px"
                                                        viewBox="0 0 14 16.5"
                                                        enableBackground="new 0 0 14 16.5"
                                                        xmlSpace="preserve">
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            fill="#3B9FD8"
                                                            d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z" />
                                                    </svg>
                                                </span><ReactTooltip id="sshCopy" effect='solid' place="top" >{ this.state.isSshCopy ? "copy" : "copied" }</ReactTooltip>
                                            </li>
                                            <li style={ { display: this.state.privIpv4Add ? 'block' : 'none' } } onClick={ (e) => this.copyToclipboard(e, this.state.privIpv4Add) }>{ this.state.privIpv4Add }
                                                <span className="svg_wrap">
                                                    <svg
                                                        x="0px"
                                                        y="0px"
                                                        width="14px"
                                                        height="16.5px"
                                                        viewBox="0 0 14 16.5"
                                                        enableBackground="new 0 0 14 16.5"
                                                        xmlSpace="preserve">
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            fill="#3B9FD8"
                                                            d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z" />
                                                    </svg>
                                                </span>
                                            </li>
                                            <li style={ { display: this.state.ipv4Address.length > 0 ? 'block' : 'none' } } >
                                                <span className="ip_addr"> { this.state.resultIP } </span>
                                                <span className="svg_wrap" data-tip data-for="ipv4Copy" onMouseLeave={ () => this.setState({ isIpv4Copy: true }) } onClick={ (e) => this.copyToclipboard(e, this.state.resultIP, 'isIpv4Copy') }>
                                                    <svg
                                                        x="0px"
                                                        y="0px"
                                                        width="14px"
                                                        height="16.5px"
                                                        viewBox="0 0 14 16.5"
                                                        enableBackground="new 0 0 14 16.5"
                                                        xmlSpace="preserve">
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            fill="#3B9FD8"
                                                            d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z" />
                                                    </svg>
                                                </span><ReactTooltip id="ipv4Copy" effect='solid' place="top" >{ this.state.isIpv4Copy ? "copy" : "copied" }</ReactTooltip>
                                            </li>
                                            <li style={ { display: this.state.ipv6Address ? 'block' : 'none' } }>
                                                <span className="ip_addr">{ this.state.ipv6Address }</span>
                                                <span className="svg_wrap" data-tip data-for="ipv6Copy" onClick={ (e) => this.copyToclipboard(e, this.state.ipv6Address, 'isIpv6Copy') } onMouseLeave={ () => this.setState({ isIpv6Copy: true }) }>
                                                    <svg
                                                        x="0px"
                                                        y="0px"
                                                        width="14px"
                                                        height="16.5px"
                                                        viewBox="0 0 14 16.5"
                                                        enableBackground="new 0 0 14 16.5"
                                                        xmlSpace="preserve">
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            fill="#3B9FD8"
                                                            d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z" />
                                                    </svg>
                                                </span><ReactTooltip id="ipv6Copy" effect='solid' place="top" >{ this.state.isIpv6Copy ? "copy" : "copied" }</ReactTooltip>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                { /* <div className="summaryModule_rhs_box">
                            <h3>Monthly Network Transfer</h3>
                            <div className="summaryRhs_box_content">
                                <div className="network_summary_graph"><img
                                    src="/webapp/images/circular_placeholderGraph.png"
                                    alt=""/></div>
                                <div className="ntwk_usage_wrap">
                                    <div className="ntwk_used">
                                        <span className="num_space">3568 GB</span>
                                        <span className="title_txt">Used</span>
                                    </div>
                                    <div className="ntwk_avail">
                                        <span className="num_space">6243 GB</span>
                                        <span className="title_txt">Available</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        */ }
                            </div>
                        </div>
                    </div>
                }
            </section>


        );
    }
}

export default Summary;
